function pricecal(){
  var total = 0;
  var total2 = 0;

  $(".bundle_product.active-bundle .price_block .main-price").each(function () {
    var price = parseFloat($(this).attr("price"));
    var qty = parseInt($(this).parents('.bundle_product').attr('qty'))
    var tt = price*qty;
    total += tt;
  });
    var qtyss = 0;
  $(".bundle_product.active-bundle").each(function () {
    var qtys = parseInt($(this).attr('qty'));
    qtyss += qtys;
  });
  var length = qtyss;
var aone = total.toFixed(2);
let b_dis;
if (length <= 3) {
  b_dis = parseFloat(total) * 15 / 100;
} else {
  b_dis = parseFloat(total) * 20 / 100;
}
var last_it = parseFloat(aone)-parseFloat(b_dis);
console.log(last_it);
  
  $(".bundle_product.active-bundle .price_block .compare-price").each(function () {
    var price2 = parseFloat($(this).attr("price"));
    var qty = parseInt($(this).parents('.bundle_product').attr('qty'))
    var tt = price2*qty;
    total2 += tt;
  });
  $(".bottom_btn_main span.total_main").html(" $" + last_it.toFixed(2));
  if (!isNaN(total2)) {
    $(".bottom_btn_main span.comp_price").html("$" + total2.toFixed(2));
  }
    if(aone > last_it){
    var diff = b_dis.toFixed(2);
    }
    if(!isNaN(diff)){
    $('span.diff-price').html(' $'+diff);
    }
}


$(document).ready(function () {
  $('.variant_matched .variants[index="0"]').addClass("matched");
  pricecal();
  function getSelectedOptions(element) {
    var selectedOptions = [];
    $(element)
      .parents(".bundle_product")
      .find(".product-option-bundle")
      .each(function () {
        var value = $(this).val().trim();
        // console.log('Option Value:', value);
        selectedOptions.push(value);
      });
    return selectedOptions;
  }

  function findMatchingVariant(element, selectedOptions) {
    var matchingVariant = null;
    var variantData = {};

    $(element)
      .parents(".bundle_product")
      .find(".variants")
      .each(function () {
        var variantOptions = $(this)
          .data("options")
          .split(",")
          .map(function (option) {
            return option.trim();
          });

        if (
          variantOptions.length === selectedOptions.length &&
          variantOptions.every((val, index) => val === selectedOptions[index])
        ) {
          matchingVariant = $(this).data("id");
          variantData.id = matchingVariant;
          variantData.src = $(this).data("src");
          variantData.price = $(this).data("price");
          variantData.comp = $(this).data("comp");

          // console.log('Matching Variant Data:', variantData);
          return false; // Break the loop
        }
      });

    return variantData;
  }
  
  function updateMatchingVariant(element) {
    var selectedOptions = getSelectedOptions(element);
    var matchingVariantData = findMatchingVariant(element, selectedOptions);

    if (matchingVariantData && matchingVariantData.id) {
      console.log("Matching Variant ID:", matchingVariantData.id);
      $(element)
        .parents(".bundle_product")
        .find('.variants[data-id="' + matchingVariantData.id + '"]')
        .addClass("matched");
      var qty = $(element).parents(".bundle_product").find('.variants[data-id="' + matchingVariantData.id + '"]').attr("qty");
      $(element).parents(".bundle_product").find('.qty_products input').val(1);
      $(element).parents(".bundle_product").attr('qty',1);
      if(qty < 1){
      $(element).parents(".bundle_product").removeClass('active-bundle');
      $(element).parents(".bundle_product").find('.form_btn_control').addClass('out-stock');
      }
      else{
      $(element).parents(".bundle_product").addClass('active-bundle');
      $(element).parents(".bundle_product").find('.form_btn_control').removeClass('out-stock');
      }
      $(element)
        .parents(".bundle_product")
        .find('.variants[data-id!="' + matchingVariantData.id + '"]')
        .removeClass("matched");
      $(element)
        .parents(".bundle_product")
        .attr("data-id", matchingVariantData.id);
      $(element)
        .parents(".bundle_product")
        .find(".image_block img.main-img")
        .attr("src", matchingVariantData.src);
      $(element)
        .parents(".bundle_product")
        .find(".main-price")
        .html('$'+matchingVariantData.price);
      $(element)
        .parents(".bundle_product")
        .find(".main-price")
        .attr('price',matchingVariantData.price);
      $(element)
        .parents(".bundle_product")
        .find(".compare-price")
        .html(matchingVariantData.comp);
    } else {
      console.log("No matching variant found.");
    }
       pricecal();
  }

  $(".product-option-bundle").change(function () {
    updateMatchingVariant(this);
  });

  // $(".product-option-bundle").each(function () {
  //   updateMatchingVariant(this);
  // });

var a = $('.product-options.pillow-product .package_controll.fff3 .options_block.size_and_package_box:first-child').html();
$('.product-options.pillow-product .package_controll.fff1 .options_block.size_and_package_box:nth-child(2)').html(a);
$('.product-options.pillow-product .package_controll.fff3').remove();
  
});

$(document).on("click", ".bottom_btn_main button", function () {
  // $(".bottom_btn_main span.loading-icon").fadeIn(300);
  $('.bottom_btn_main button').addClass('opacity-new');

       $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        dataType: 'json',
        success: function() {
        console.log('Cart Clear')	
	
  
  var arr = [];

  $(".bundle_product.active-bundle").each(function () {
    var id = $(this).data("id"); 
    var qty = $(this).attr('qty');
    arr.push({ quantity:qty , id: id }); 
  });

  console.log(arr);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: arr },
    dataType: "json",
    success: function (data) {
      console.log("Success: ", data);
      window.location.href = '/checkout'; 
      // $(".bottom_btn_main span.loading-icon").fadeOut(300); 
      $('.bottom_btn_main button').removeClass('opacity-new');
    },
    error: function (xhr, status, error) {
      console.error("Error: ", error);
      $(".bottom_btn_main span.loading-icon").fadeOut(300); 
      $('.bottom_btn_main button').removeClass('opacity-new');
    }
  });
        }   ,
      error: function(XMLHttpRequest, textStatus) {
        // $(".bottom_btn_main span.loading-icon").fadeOut(300); 
      $('.bottom_btn_main button').removeClass('opacity-new');
    }
    });
});

function bundle_work (){
  // var l = $('.bundle_product.active-bundle').length;
    var qtyss = 0;
    $(".bundle_product.active-bundle").each(function () {
      var qtys = parseInt($(this).attr('qty'));
      qtyss += qtys;
    });
  var length = qtyss;
  var buy1 = $('.buy1').attr('data-val');
  var buy2 = $('.buy2').attr('data-val');
  var buy3 = $('.buy3').attr('data-val');
  var buy4 = $('.buy4').attr('data-val');
  console.log('length : ',length);
  if(length == 4 || length > 4){
  $('span.calculation_text').html(buy4);
  $('.bottom_btn_main button').removeClass('disabled');
  $('.total_main , span.price-divider').show();
  $('.total_main , .tierr-new').show();
  }
  else if (length==3){
  $('.bundle_product:not(.active-bundle) span.discount_percantage').html('Add 1 More Product for a Discount');
  $('span.calculation_text').html(buy3);
  $('.bottom_btn_main button').removeClass('disabled');
  $('.tierr-new').show();
  $('.total_main , span.price-divider').show();
    // $('.total_main').hide();
  }
  else if (length==2){
  $('span.discount_percantage , span.price-divider').hide();
  // $('.bundle_product:not(.active-bundle) span.discount_percantage').html(buy3.split('for')[1]);
  $('span.calculation_text').html(buy2);
  $('.bottom_btn_main button').addClass('disabled');
   $('span.discount_percantage , .total_main').hide();
  // $('.total_main , span.price-divider').show();
    $('.tierr-new').show();
  }
  else if (length==1){
  // $('.total_main , span.price-divider').show();
  $('span.calculation_text').html(buy1);
  $('.bottom_btn_main button').addClass('disabled disabled-1');
  $('span.discount_percantage , .total_main , span.price-divider').hide();
  $('.tierr-new').show();
  
  }
  else if (length < 1){
  $('.total_main , span.price-divider').hide();
  $('span.calculation_text').html('Add 4 Products for a Discount');
  $('.bottom_btn_main button').addClass('disabled');
    $('.bottom_btn_main button').removeClass('disabled-1');
  $(".bottom_btn_main span.total_main").html('');
  $(".bottom_btn_main span.comp_price").html('');
  $('span.discount_percantage , .total_main , .tierr-new').hide();
  }
}

$(document).on(
  "click",
  ".form_btn_control button.product-bundle-active ,.form_btn_control button.product-form__cart-submit",function () {
  $(this).parents(".bundle_product").toggleClass("active-bundle");
  pricecal();
  bundle_work();
});

$(document).on('click','.icon_popup',function(){
var html = $(this).parents('.bundle_product').find('.product_details_popup').html();
$('.pop-up-details .main_d').html(html);
$('.pop-up-details').fadeIn(300);
$('#overlay').fadeIn(300);
});

$(document).on('click','span.cross-btn',function(){
  $('.pop-up-details').fadeOut(300);
  $('#overlay').fadeOut(300);
});


$(document).on('click', '.add-qty', function() {
    var qty_b = parseInt($(this).parents('.qty_products').find('input').val()) || 0;
    var var_qty = parseInt($(this).parents('.bundle_product').find('.variant_matched .variants.matched').attr('qty')) || 0;
    if (qty_b === var_qty) {alert(`This variant only have ${qty_b} qty`);return false;}
    $(this).prev().val(function(i, oldVal) {
        return +oldVal + 1;
    });
    var qty = $(this).parents('.qty_products').find('input').val();
    $(this).parents('.bundle_product').attr('qty', qty);
    pricecal();
   bundle_work();
});


$(document).on('click','.sub-qty',function(){
		if ($(this).next().val() > 1) {
    	if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
       var qty = $(this).parents('.qty_products').find('input').val();
       $(this).parents('.bundle_product').attr('qty',qty);
       pricecal();
       bundle_work();
});

$(document).on('click','.options_block label.color-swatch-new',function(){
      $(this).parents('.color_option_wrapper').find('label').removeClass('active');
      $(this).addClass('active');
      var val = $(this).attr('data-option');
      $(this).parents('.options_block').siblings('.options_block.color_only').find('select').val(val).change();
      $(this).parents('.options_block').find('label.form__label span.current-option-selected').html(val);
      pricecal();
      bundle_work();
});

$(document).on('click','.flex_control .size_label',function(){
      $(this).parents('.options_block').find('.size_label').removeClass('active');
      $(this).addClass('active');
      var val = $(this).attr('value');
      $(this).parents('.options_block').find('select').val(val).change();
      $(this).parents('.options_block').find('label span.current-option-selected').html(val);
      pricecal();
      bundle_work();
});
$('.flex_control .size_label:first-child').click();

    let selectedOptions = [];
    $('.product-options.pillow-product select').each(function() {
        selectedOptions.push($(this).val());
        $(this).parents('.bundle_product').find('.variant_matched .variants').removeClass('matched')
    });
    let result = [selectedOptions[0], selectedOptions[2], selectedOptions[1]].join(',');
    console.log(result);
    $('.variant_matched .variants[data-options="'+result+'"]').addClass('matched');

    $(document).on('click','.product-options.pillow-product span.color_option , .product-options.pillow-product .size_label , .product-options.pillow-product .size_label',function(){
    let selectedOptions = [];
    $('.product-options.pillow-product select').each(function() {
        selectedOptions.push($(this).val());
        $(this).parents('.bundle_product').find('.variant_matched .variants').removeClass('matched')
    });
    let result = [selectedOptions[0], selectedOptions[2], selectedOptions[1]].join(',');
    $('.variant_matched .variants[data-options="'+result+'"]').addClass('matched');
    var price = $(this).parents('.bundle_product').find('.variant_matched .variants.matched').attr('data-price'); 
    var idd = $(this).parents('.bundle_product').find('.variant_matched .variants.matched').attr('data-id'); 
    var immgg = $(this).parents('.bundle_product').find('.variant_matched .variants.matched').attr('data-src'); 

    $(this).parents('.bundle_product').attr("data-id", idd);
    $(this).parents('.bundle_product').find(".image_block img.main-img").attr("src", immgg);
    $(this).parents('.bundle_product').find(".main-price").html(price);
    $(this).parents('.bundle_product').find(".main-price").attr('price',price);
    var qty = $(this).parents('.bundle_product').find('.variant_matched .variants.matched').attr("qty");
    $(this).parents('.bundle_product').find('.qty_products input').val(1);
    $(this).parents('.bundle_product').attr('qty',1);
    if(qty < 1){
    $(this).parents('.bundle_product').removeClass('active-bundle');
    $(this).parents('.bundle_product').find('.form_btn_control').addClass('out-stock');
    }
    else{
    $(this).parents('.bundle_product').addClass('active-bundle');
    $(this).parents('.bundle_product').find('.form_btn_control').removeClass('out-stock');
    }
    pricecal();
    bundle_work();
    });


    $(document).on('change', '.prod-price select.variants_ss', function() {
    var vv = $(this).val();
    var selectedOption = $(this).find('option:selected');
    var img = selectedOption.attr('srcimg');
    $(this).parents('.extra-prod').find('.btn_added button').attr('data-id', vv);
    if (img) {
    $(this).parents('.extra-prod').find('.pp_img img').attr('src', img);
    } else {
    console.warn('srcimg attribute is undefined for the selected option.');
    }
    });

